module.exports = __webpack_public_path__ + "img/advantage-6.4677c4fe.png";